@import '../../constants/spacing.module.less';

.modal {
  width: 100%;
  max-width: 800px;
}

.modalBody {
  display: flex;
  min-height: 600px;
}

.mainContent {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: @space-16;
  gap: @space-8;
}

.datePicker {
  width: 200px;
}

.sidebar {
  width: 280px;
  padding: @space-16;
  border-left: 1px solid var(--default--border-color--1);
  background-color: var(--gray-F9FAFB);
}

.bodyNote {
  margin-top: auto;
}

.footer {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}

.footerNote {
  color: var(--gray-637381);
}

.buttons {
  display: flex;
  gap: @space-12;
  align-items: center;
}
